import { ANALISE_MODEL } from 'utils/models';
import * as _ from 'lodash';
import moment from 'moment';
import api from './api';
import { ALERTAS_ROUTE, MONITORAMENTO_ROUTE, UPLOAD_ROUTE } from '../constants/apiRoutes';
import DateHelper from '../utils/dateHelper';

function createAnalise(analise) {
	const analiseSalvar = _.cloneDeep(analise);

	if (!analiseSalvar.registroAnalise) return analise;

	for (let i = 0; i < analiseSalvar.registroAnalise.length; i++) {
		const data = DateHelper.convertStringToDate(
			analiseSalvar.registroAnalise[i].dataAnalise,
			'YYYY/MM/DD',
		);

		analiseSalvar.registroAnalise[i].dataAnalise = DateHelper.isDataValida(data)
			? data : analiseSalvar.registroAnalise[i].dataAnalise;
	}

	return analiseSalvar;
}

export default {
	async findMonitoramentoByAlertaId(id) {
		const { data } = await api.get(ALERTAS_ROUTE.FIND_BY_ID.replace('{alertaId}', id));

		let { monitoramento: analise } = data;

		analise = analise || ANALISE_MODEL.monitoramento;

		analise.alertaId = data.id;

		analise.alertaStatus = data.statusAtualAlerta;

		return analise;
	},

	async saveAnalise(analise) {
		const dados = createAnalise(analise);
		return api.post(MONITORAMENTO_ROUTE.CREATE, dados);
	},

	async saveRegistro(registro) {
		const cloneRegistro = {
			...registro,
		};

		cloneRegistro.horaAnalise = moment(registro.horaAnalise, 'HH:mm').format('HH:mm:ss');
		return api.post(MONITORAMENTO_ROUTE.CREATE, cloneRegistro);
	},

	async uploadDocumentoRegistro(registro, documento) {
		const cloneRegistro = {
			...registro,
		};

		const dataForm = new FormData();
		dataForm.append('arquivo', documento[0].file);

		const { data } = await api.post(UPLOAD_ROUTE.UPLOAD_ARQUIVO, dataForm);
		cloneRegistro.fileField = documento;
		cloneRegistro.documento = data.data;

		return cloneRegistro;
	},
};
